var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _g2, _path16, _g3, _path17, _g4, _path18, _g5, _path19, _g6, _path20, _path21, _g7, _g8, _path22, _path23, _g9, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g10, _path32, _g11, _path33, _g12, _path34, _g13, _path35, _g14, _path36, _g15, _path37, _path38, _g16, _g17, _path39, _path40, _g18, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskWalkthrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 214,
    viewBox: "0 0 274 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_309_2269)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_2269)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M258.531 -3H16.4687C5.16413 -3 -4 6.99101 -4 19.3155V188.684C-4 201.009 5.16413 211 16.4687 211H258.531C269.836 211 279 201.009 279 188.684V19.3155C279 6.99101 269.836 -3 258.531 -3Z",
    fill: "#1467B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05985 211H265.94C278.118 211 288 200.963 288 188.592V179H-17V188.592C-17 200.963 -7.11839 211 5.05985 211Z",
    fill: "#9FC1DF",
    fillOpacity: 0.89
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_309_2269)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.848 67.0281C215.146 67.0281 209.69 61.5596 209.69 54.8421C209.69 48.1246 215.146 42.6561 221.848 42.6561C228.55 42.6561 234.006 48.1246 234.006 54.8421C234.006 61.5596 228.55 67.0281 221.848 67.0281ZM221.848 44.0964C215.932 44.0964 211.121 48.9179 211.121 54.8477C211.121 60.7776 215.932 65.5991 221.848 65.5991C227.764 65.5991 232.574 60.7776 232.574 54.8477C232.574 48.9179 227.764 44.0964 221.848 44.0964Z",
    fill: "#5363BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.997 23.2576C97.2952 23.2576 91.8394 28.7261 91.8394 35.4436C91.8394 42.161 97.2952 47.6295 103.997 47.6295C110.699 47.6295 116.155 42.161 116.155 35.4436C116.155 28.7261 110.699 23.2576 103.997 23.2576ZM103.997 46.1893C98.081 46.1893 93.2707 41.3678 93.2707 35.4379C93.2707 29.5081 98.081 24.6866 103.997 24.6866C109.913 24.6866 114.724 29.5081 114.724 35.4379C114.724 41.3678 109.913 46.1893 103.997 46.1893Z",
    fill: "#5363BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.029 47.7139C181.462 47.7139 176.119 42.358 176.119 35.7755C176.119 29.193 181.462 23.8371 188.029 23.8371C194.597 23.8371 199.94 29.193 199.94 35.7755C199.94 42.358 194.597 47.7139 188.029 47.7139ZM188.029 25.2436C182.237 25.2436 177.522 29.9694 177.522 35.7755C177.522 41.5816 182.237 46.3074 188.029 46.3074C193.822 46.3074 198.537 41.5816 198.537 35.7755C198.537 29.9694 193.822 25.2436 188.029 25.2436Z",
    fill: "#5363BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.2 39.8769C140.633 39.8769 135.29 34.5209 135.29 27.9384C135.29 21.356 140.633 16 147.2 16C153.768 16 159.111 21.356 159.111 27.9384C159.111 34.5209 153.768 39.8769 147.2 39.8769ZM147.2 17.4065C141.408 17.4065 136.693 22.1324 136.693 27.9384C136.693 33.7445 141.408 38.4704 147.2 38.4704C152.993 38.4704 157.708 33.7445 157.708 27.9384C157.708 22.1324 152.993 17.4065 147.2 17.4065Z",
    fill: "#5363BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9108 42.7405C55.3436 42.7405 50 48.0965 50 54.679C50 61.2614 55.3436 66.6174 61.9108 66.6174C68.478 66.6174 73.8216 61.2614 73.8216 54.679C73.8216 48.0965 68.478 42.7405 61.9108 42.7405ZM61.9108 65.2109C56.1182 65.2109 51.4033 60.4907 51.4033 54.679C51.4033 48.8673 56.1182 44.147 61.9108 44.147C67.7034 44.147 72.424 48.8729 72.424 54.679C72.424 60.485 67.709 65.2109 61.9108 65.2109Z",
    fill: "#5363BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7932 64.1476L75.7917 72.1647",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.601 46.7069L111.81 55.7085",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.999 65L207 73.0171",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.617 47.9492L179.795 57.8903",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.593 41.2524V51.8012",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.301 47.4436V50.3895C61.301 50.7227 61.8194 50.7227 61.8194 50.3895V47.4436C61.8194 47.1105 61.301 47.1105 61.301 47.4436Z",
    fill: "#5363BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.301 47.4436V50.3895C61.301 50.7227 61.8194 50.7227 61.8194 50.3895V47.4436C61.8194 47.1105 61.301 47.1105 61.301 47.4436Z",
    fill: "#5363BC"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6179 49.8265H61.5024C60.7819 49.8265 60.1978 50.4083 60.1978 51.126V52.5502C60.1978 53.2679 60.7819 53.8498 61.5024 53.8498H61.6179C62.3384 53.8498 62.9226 53.2679 62.9226 52.5502V51.126C62.9226 50.4083 62.3384 49.8265 61.6179 49.8265Z",
    fill: "#5363BC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6179 49.8265H61.5024C60.7819 49.8265 60.1978 50.4083 60.1978 51.126V52.5502C60.1978 53.2679 60.7819 53.8498 61.5024 53.8498H61.6179C62.3384 53.8498 62.9226 53.2679 62.9226 52.5502V51.126C62.9226 50.4083 62.3384 49.8265 61.6179 49.8265Z",
    fill: "#5363BC"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0165 58.0699L65.2854 58.0426C65.2854 58.0426 65.2874 56.9418 64.9314 55.9208C64.8101 55.5721 64.6927 55.3578 64.5812 55.2779C64.4013 55.1512 64.1744 55.0831 63.924 55.0831H55.3643V53.0373H63.924C64.4854 53.0373 65.0194 53.2049 65.4673 53.5205C66.06 53.9374 66.3574 54.6447 66.5314 55.1396C67.0263 56.5599 67.0165 58.0075 67.0146 58.0679L67.0165 58.0699Z",
    fill: "#5363BC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0165 58.0699L65.2854 58.0426C65.2854 58.0426 65.2874 56.9418 64.9314 55.9208C64.8101 55.5721 64.6927 55.3578 64.5812 55.2779C64.4013 55.1512 64.1744 55.0831 63.924 55.0831H55.3643V53.0373H63.924C64.4854 53.0373 65.0194 53.2049 65.4673 53.5205C66.06 53.9374 66.3574 54.6447 66.5314 55.1396C67.0263 56.5599 67.0165 58.0075 67.0146 58.0679L67.0165 58.0699Z",
    fill: "#5363BC"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.465 56.2988C62.702 56.2988 63.7047 55.4335 63.7047 54.3661C63.7047 53.2986 62.702 52.4333 61.465 52.4333C60.2281 52.4333 59.2253 53.2986 59.2253 54.3661C59.2253 55.4335 60.2281 56.2988 61.465 56.2988Z",
    fill: "#5363BC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.465 56.2988C62.702 56.2988 63.7047 55.4335 63.7047 54.3661C63.7047 53.2986 62.702 52.4333 61.465 52.4333C60.2281 52.4333 59.2253 53.2986 59.2253 54.3661C59.2253 55.4335 60.2281 56.2988 61.465 56.2988Z",
    fill: "#5363BC"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8207 47.5118H64.1412C64.4757 47.5118 64.4757 46.9955 64.1412 46.9955H58.8207C58.4862 46.9955 58.4862 47.5118 58.8207 47.5118Z",
    fill: "#5363BC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8207 47.5118H64.1412C64.4757 47.5118 64.4757 46.9955 64.1412 46.9955H58.8207C58.4862 46.9955 58.4862 47.5118 58.8207 47.5118Z",
    fill: "#5363BC"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2675 52.0963H55.0552V55.9637H57.2675V52.0963Z",
    fill: "#5363BC"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2675 52.0963H55.0552V55.9637H57.2675V52.0963Z",
    fill: "#5363BC"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2841 47.3306C59.2841 47.7651 58.9301 48.1158 58.4958 48.1158C58.0616 48.1158 57.7075 47.7632 57.7075 47.3306C57.7075 46.8981 58.0616 46.5455 58.4958 46.5455C58.9301 46.5455 59.2841 46.8981 59.2841 47.3306Z",
    fill: "#5363BC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4889 47.3306C65.4889 47.7651 65.1349 48.1158 64.7006 48.1158C64.2664 48.1158 63.9124 47.7632 63.9124 47.3306C63.9124 46.8981 64.2664 46.5455 64.7006 46.5455C65.1349 46.5455 65.4889 46.8981 65.4889 47.3306Z",
    fill: "#5363BC"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2841 47.3306C59.2841 47.7651 58.9301 48.1158 58.4958 48.1158C58.0616 48.1158 57.7075 47.7632 57.7075 47.3306C57.7075 46.8981 58.0616 46.5455 58.4958 46.5455C58.9301 46.5455 59.2841 46.8981 59.2841 47.3306Z",
    fill: "#5363BC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4889 47.3306C65.4889 47.7651 65.1349 48.1158 64.7006 48.1158C64.2664 48.1158 63.9124 47.7632 63.9124 47.3306C63.9124 46.8981 64.2664 46.5455 64.7006 46.5455C65.1349 46.5455 65.4889 46.8981 65.4889 47.3306Z",
    fill: "#5363BC"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1324 58.7459C65.6708 59.1707 65.0898 59.8584 64.8473 60.4351C64.6047 61.0118 64.5832 61.7113 64.9275 62.2335C65.2424 62.7127 65.8507 62.9816 66.418 62.892C66.9852 62.8024 67.4821 62.3601 67.6327 61.8087C67.7638 61.3294 67.6464 60.8092 67.4156 60.3669C67.1848 59.9266 66.463 59.1161 66.1304 58.7459",
    fill: "#407BFF",
    fillOpacity: 0.63
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1978 47.1826C60.1978 47.1826 60.5538 46.5455 61.5592 46.5455C62.5646 46.5455 62.8345 47.3306 62.8345 47.3306L62.1832 48.2678V48.7763H60.8237V48.1976L60.1978 47.1826Z",
    fill: "#5363BC"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1978 47.1826C60.1978 47.1826 60.5538 46.5455 61.5592 46.5455C62.5646 46.5455 62.8345 47.3306 62.8345 47.3306L62.1832 48.2678V48.7763H60.8237V48.1976L60.1978 47.1826Z",
    fill: "#5363BC"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2793 53.0373V55.0831C57.2793 55.1766 57.426 55.1766 57.426 55.0831V53.0373C57.426 52.9438 57.2793 52.9438 57.2793 53.0373Z",
    fill: "#5363BC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3243 48.8893H61.8094C61.8486 48.8893 61.8838 48.8562 61.8838 48.8153C61.8838 48.7744 61.8525 48.7412 61.8094 48.7412H61.3243C61.2852 48.7412 61.25 48.7744 61.25 48.8153C61.25 48.8562 61.2813 48.8893 61.3243 48.8893Z",
    fill: "#5363BC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6598 53.1055C59.2588 53.5984 59.1003 54.2531 59.2373 54.8746C59.2568 54.9662 59.3996 54.9272 59.3781 54.8356C59.2529 54.2706 59.3957 53.6588 59.7615 53.2088C59.8202 53.1367 59.7165 53.0315 59.6578 53.1055H59.6598Z",
    fill: "#5363BC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1045 53.1484C63.4742 53.6569 63.6444 54.2979 63.5583 54.9214C63.5465 55.0129 63.6874 55.0538 63.6991 54.9603C63.7911 54.2979 63.6267 53.6179 63.2316 53.0743C63.1769 52.9983 63.0497 53.0724 63.1045 53.1484Z",
    fill: "#5363BC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0933 57.8419C79.1202 49.4703 73.9767 41.0407 65.6051 39.0139C57.2336 36.987 48.804 42.1304 46.7771 50.502C44.7503 58.8736 49.8937 67.3032 58.2653 69.3301C66.6369 71.3569 75.0665 66.2135 77.0933 57.8419Z",
    fill: "#F3E1E6"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.395 54.6875C76.8641 46.2002 71.1747 38.129 62.6875 36.66C54.2002 35.1909 46.129 40.8803 44.66 49.3675C43.1909 57.8548 48.8803 65.926 57.3675 67.395C65.8548 68.8641 73.926 63.1747 75.395 54.6875Z",
    fill: "#F5F7FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0985 64.4636C66.9786 64.4143 72.5162 58.797 72.4669 51.9169C72.4177 45.0367 66.8003 39.4992 59.9202 39.5485C53.0401 39.5977 47.5026 45.215 47.5518 52.0952C47.601 58.9753 53.2184 64.5128 60.0985 64.4636Z",
    fill: "#C5CDFF",
    fillOpacity: 0.38
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8679 44.1888V47.6778C59.8679 48.0724 60.4794 48.0724 60.4794 47.6778V44.1888C60.4794 43.7942 59.8679 43.7942 59.8679 44.1888Z",
    fill: "#606CC6"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8679 44.1888V47.6778C59.8679 48.0724 60.4794 48.0724 60.4794 47.6778V44.1888C60.4794 43.7942 59.8679 43.7942 59.8679 44.1888Z",
    fill: "white"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2419 47.0109H60.1058C59.2557 47.0109 58.5667 47.7 58.5667 48.55V50.2368C58.5667 51.0869 59.2557 51.776 60.1058 51.776H60.2419C61.092 51.776 61.7811 51.0869 61.7811 50.2368V48.55C61.7811 47.7 61.092 47.0109 60.2419 47.0109Z",
    fill: "#606CC6"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2419 47.0109H60.1058C59.2557 47.0109 58.5667 47.7 58.5667 48.55V50.2368C58.5667 51.0869 59.2557 51.776 60.1058 51.776H60.2419C61.092 51.776 61.7811 51.0869 61.7811 50.2368V48.55C61.7811 47.7 61.092 47.0109 60.2419 47.0109Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6105 56.7741L64.5683 56.7418C64.5683 56.7418 64.5706 55.438 64.1507 54.2289C64.0076 53.8158 63.8692 53.562 63.7376 53.4674C63.5253 53.3174 63.2577 53.2366 62.9623 53.2366H52.8645V50.8137H62.9623C63.6246 50.8137 64.2545 51.0122 64.7829 51.386C65.4821 51.8798 65.8329 52.7174 66.0382 53.3036C66.622 54.9858 66.6105 56.7003 66.6082 56.7718L66.6105 56.7741Z",
    fill: "#606CC6"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6105 56.7741L64.5683 56.7418C64.5683 56.7418 64.5706 55.438 64.1507 54.2289C64.0076 53.8158 63.8692 53.562 63.7376 53.4674C63.5253 53.3174 63.2577 53.2366 62.9623 53.2366H52.8645V50.8137H62.9623C63.6246 50.8137 64.2545 51.0122 64.7829 51.386C65.4821 51.8798 65.8329 52.7174 66.0382 53.3036C66.622 54.9858 66.6105 56.7003 66.6082 56.7718L66.6105 56.7741Z",
    fill: "#C5CDFF"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0618 54.6765C61.521 54.6765 62.7039 53.6517 62.7039 52.3875C62.7039 51.1232 61.521 50.0984 60.0618 50.0984C58.6026 50.0984 57.4197 51.1232 57.4197 52.3875C57.4197 53.6517 58.6026 54.6765 60.0618 54.6765Z",
    fill: "#606CC6"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0618 54.6765C61.521 54.6765 62.7039 53.6517 62.7039 52.3875C62.7039 51.1232 61.521 50.0984 60.0618 50.0984C58.6026 50.0984 57.4197 51.1232 57.4197 52.3875C57.4197 53.6517 58.6026 54.6765 60.0618 54.6765Z",
    fill: "white"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9422 44.2695H63.2187C63.6133 44.2695 63.6133 43.658 63.2187 43.658H56.9422C56.5476 43.658 56.5476 44.2695 56.9422 44.2695Z",
    fill: "#606CC6"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9422 44.2695H63.2187C63.6133 44.2695 63.6133 43.658 63.2187 43.658H56.9422C56.5476 43.658 56.5476 44.2695 56.9422 44.2695Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1098 49.6992H52.5V54.2796H55.1098V49.6992Z",
    fill: "#606CC6"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1098 49.6992H52.5V54.2796H55.1098V49.6992Z",
    fill: "white"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4888 44.0549C57.4888 44.5695 57.0711 44.9849 56.5588 44.9849C56.0466 44.9849 55.6289 44.5672 55.6289 44.0549C55.6289 43.5427 56.0466 43.125 56.5588 43.125C57.0711 43.125 57.4888 43.5427 57.4888 44.0549Z",
    fill: "#606CC6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8084 44.0549C64.8084 44.5695 64.3907 44.9849 63.8784 44.9849C63.3662 44.9849 62.9485 44.5672 62.9485 44.0549C62.9485 43.5427 63.3662 43.125 63.8784 43.125C64.3907 43.125 64.8084 43.5427 64.8084 44.0549Z",
    fill: "#606CC6"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4888 44.0549C57.4888 44.5695 57.0711 44.9849 56.5588 44.9849C56.0466 44.9849 55.6289 44.5672 55.6289 44.0549C55.6289 43.5427 56.0466 43.125 56.5588 43.125C57.0711 43.125 57.4888 43.5427 57.4888 44.0549Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8084 44.0549C64.8084 44.5695 64.3907 44.9849 63.8784 44.9849C63.3662 44.9849 62.9485 44.5672 62.9485 44.0549C62.9485 43.5427 63.3662 43.125 63.8784 43.125C64.3907 43.125 64.8084 43.5427 64.8084 44.0549Z",
    fill: "white"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5676 57.5748C65.023 58.0779 64.3377 58.8924 64.0516 59.5754C63.7654 60.2585 63.7401 61.0869 64.1462 61.7053C64.5177 62.273 65.2353 62.5914 65.9045 62.4853C66.5737 62.3791 67.1598 61.8553 67.3375 61.2023C67.4921 60.6346 67.3537 60.0185 67.0814 59.4947C66.8091 58.9732 65.9576 58.0132 65.5653 57.5748",
    fill: "#407BFF",
    fillOpacity: 0.56
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5667 43.8796C58.5667 43.8796 58.9866 43.125 60.1727 43.125C61.3588 43.125 61.6772 44.0549 61.6772 44.0549L60.9088 45.1649V45.7671H59.3051V45.0818L58.5667 43.8796Z",
    fill: "#5460C6"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5667 43.8796C58.5667 43.8796 58.9866 43.125 60.1727 43.125C61.3588 43.125 61.6772 44.0549 61.6772 44.0549L60.9088 45.1649V45.7671H59.3051V45.0818L58.5667 43.8796Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1235 50.8137V53.2366C55.1235 53.3474 55.2966 53.3474 55.2966 53.2366V50.8137C55.2966 50.703 55.1235 50.703 55.1235 50.8137Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8958 45.901H60.4681C60.5142 45.901 60.5557 45.8617 60.5557 45.8133C60.5557 45.7648 60.5188 45.7256 60.4681 45.7256H59.8958C59.8496 45.7256 59.8081 45.7648 59.8081 45.8133C59.8081 45.8617 59.845 45.901 59.8958 45.901Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9319 50.8945C57.4588 51.4783 57.2719 52.2536 57.4334 52.9897C57.4565 53.0982 57.625 53.052 57.5996 52.9436C57.4519 52.2744 57.6203 51.5498 58.0518 51.0168C58.1211 50.9314 57.9988 50.8068 57.9295 50.8945H57.9319Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9956 50.9453C62.4317 51.5475 62.6324 52.3067 62.5309 53.0451C62.5171 53.1536 62.6832 53.202 62.697 53.0913C62.8055 52.3067 62.6117 51.5014 62.1455 50.8576C62.0809 50.7676 61.9309 50.8553 61.9956 50.9453Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.093 39.8419C122.12 31.4703 116.977 23.0407 108.605 21.0139C100.234 18.987 91.804 24.1304 89.7771 32.502C87.7503 40.8736 92.8937 49.3032 101.265 51.3301C109.637 53.3569 118.066 48.2135 120.093 39.8419Z",
    fill: "#F3E1E6"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M118.395 36.6875C119.864 28.2002 114.175 20.129 105.687 18.66C97.2002 17.1909 89.129 22.8803 87.66 31.3675C86.1909 39.8548 91.8803 47.926 100.368 49.395C108.855 50.8641 116.926 45.1747 118.395 36.6875Z",
    fill: "#F5F7FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M103.099 46.4636C109.979 46.4143 115.516 40.797 115.467 33.9169C115.418 27.0367 109.8 21.4992 102.92 21.5485C96.0401 21.5977 90.5026 27.215 90.5518 34.0952C90.601 40.9753 96.2184 46.5128 103.099 46.4636Z",
    fill: "#C5CDFF",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M206.093 39.8419C208.12 31.4703 202.977 23.0407 194.605 21.0139C186.234 18.987 177.804 24.1304 175.777 32.502C173.75 40.8736 178.894 49.3032 187.265 51.3301C195.637 53.3569 204.066 48.2135 206.093 39.8419Z",
    fill: "#F3E1E6"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M204.395 36.6875C205.864 28.2002 200.175 20.129 191.687 18.66C183.2 17.1909 175.129 22.8803 173.66 31.3675C172.191 39.8548 177.88 47.926 186.368 49.395C194.855 50.8641 202.926 45.1747 204.395 36.6875Z",
    fill: "#F5F7FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M189.099 46.4636C195.979 46.4143 201.516 40.797 201.467 33.9169C201.418 27.0367 195.8 21.4992 188.92 21.5485C182.04 21.5977 176.503 27.215 176.552 34.0952C176.601 40.9753 182.218 46.5128 189.099 46.4636Z",
    fill: "#C5CDFF",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 33.8419C166.12 25.4703 160.977 17.0407 152.605 15.0139C144.234 12.987 135.804 18.1304 133.777 26.502C131.75 34.8736 136.894 43.3032 145.265 45.3301C153.637 47.3569 162.066 42.2135 164.093 33.8419Z",
    fill: "#F3E1E6"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M162.395 30.6875C163.864 22.2002 158.175 14.129 149.687 12.66C141.2 11.1909 133.129 16.8803 131.66 25.3675C130.191 33.8548 135.88 41.926 144.368 43.395C152.855 44.8641 160.926 39.1747 162.395 30.6875Z",
    fill: "#F5F7FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M147.099 40.4636C153.979 40.4143 159.516 34.797 159.467 27.9169C159.418 21.0367 153.8 15.4992 146.92 15.5485C140.04 15.5977 134.503 21.215 134.552 28.0952C134.601 34.9753 140.218 40.5128 147.099 40.4636Z",
    fill: "#C5CDFF",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M240.093 59.8419C242.12 51.4703 236.977 43.0407 228.605 41.0139C220.234 38.987 211.804 44.1304 209.777 52.502C207.75 60.8736 212.894 69.3032 221.265 71.3301C229.637 73.3569 238.066 68.2135 240.093 59.8419Z",
    fill: "#F3E1E6"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M238.395 56.6875C239.864 48.2002 234.175 40.129 225.687 38.66C217.2 37.1909 209.129 42.8803 207.66 51.3675C206.191 59.8548 211.88 67.926 220.368 69.395C228.855 70.8641 236.926 65.1747 238.395 56.6875Z",
    fill: "#F5F7FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M223.099 66.4636C229.979 66.4143 235.516 60.797 235.467 53.9169C235.418 47.0367 229.8 41.4992 222.92 41.5485C216.04 41.5977 210.503 47.215 210.552 54.0952C210.601 60.9753 216.218 66.5128 223.099 66.4636Z",
    fill: "#C5CDFF",
    fillOpacity: 0.38
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M103.01 26C98.5923 26 95 29.6007 95 34.0283C95 38.456 98.5923 42.0567 103.01 42.0567C107.427 42.0567 111.02 38.456 111.02 34.0283C111.02 29.6007 107.427 26 103.01 26ZM108.219 38.5686L107.472 37.8203C107.259 37.6065 106.911 37.6065 106.698 37.8203C106.484 38.0341 106.484 38.3829 106.698 38.5967L107.438 39.3393C106.361 40.2451 105.002 40.819 103.515 40.9259V39.8963C103.515 39.5925 103.268 39.3449 102.965 39.3449C102.662 39.3449 102.415 39.5925 102.415 39.8963V40.9202C100.939 40.7908 99.5914 40.2001 98.525 39.2831L99.249 38.5573C99.4623 38.3435 99.4623 37.9947 99.249 37.7809C99.0358 37.5671 98.6877 37.5671 98.4745 37.7809L97.7504 38.5067C96.8411 37.4321 96.2517 36.0818 96.1282 34.5966H97.1722C97.4753 34.5966 97.7223 34.349 97.7223 34.0452C97.7223 33.7414 97.4753 33.4939 97.1722 33.4939H96.1226C96.2349 31.9973 96.8242 30.6358 97.7335 29.55L98.5025 30.3208C98.6092 30.4277 98.7495 30.4839 98.8898 30.4839C99.0301 30.4839 99.1705 30.4277 99.2771 30.3208C99.4904 30.107 99.4904 29.7582 99.2771 29.5444L98.5081 28.7736C99.5858 27.8453 100.955 27.2434 102.454 27.1252V28.2448C102.454 28.5486 102.701 28.7961 103.004 28.7961C103.307 28.7961 103.554 28.5486 103.554 28.2448V27.1252C105.059 27.2434 106.428 27.851 107.511 28.7849L106.72 29.5782C106.507 29.7919 106.507 30.1408 106.72 30.3545C106.827 30.4614 106.967 30.5177 107.107 30.5177C107.248 30.5177 107.388 30.4614 107.495 30.3545L108.286 29.5613C109.207 30.6527 109.79 32.0311 109.891 33.5389H108.797C108.494 33.5389 108.247 33.7864 108.247 34.0902C108.247 34.394 108.494 34.6416 108.797 34.6416H109.886C109.751 36.1381 109.145 37.494 108.213 38.5629L108.219 38.5686Z",
    fill: "#BFC4E8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M103.56 34.1746V31.1366C103.56 30.8328 103.313 30.5852 103.01 30.5852C102.707 30.5852 102.46 30.8328 102.46 31.1366V34.3715C102.46 34.3715 102.465 34.394 102.465 34.4053C102.465 34.4165 102.465 34.4222 102.465 34.4334C102.482 34.5684 102.533 34.6866 102.628 34.771L103.61 36.3631C103.717 36.5319 103.897 36.6219 104.076 36.6219C104.177 36.6219 104.273 36.5938 104.363 36.5376C104.621 36.38 104.699 36.0368 104.542 35.778L103.549 34.169L103.56 34.1746Z",
    fill: "#BFC4E8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M147.321 34.4504C144.009 32.3406 142 28.6837 142 24.7511V23.5078L147.321 22L152.642 23.5078V24.7511C152.642 28.6837 150.633 32.3406 147.321 34.4504Z",
    fill: "#BFC4E8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M228.01 52.0112C228.01 53.1027 227.656 54.1097 227.067 54.9424C226.146 56.2195 225.646 57.761 225.646 59.3419V59.4995H220.365V59.3419C220.365 57.7273 219.798 56.1857 218.883 54.858C218.226 53.9128 217.895 52.7257 218.03 51.4599C218.277 49.1588 220.14 47.2854 222.436 47.0322C225.456 46.6946 228.015 49.0575 228.015 52.0168L228.01 52.0112Z",
    fill: "#BFC4E8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M225.197 59.9383H220.808V61.4686H225.197V59.9383Z",
    fill: "#BFC4E8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M224.541 61.9074H221.465V62.9482H224.541V61.9074Z",
    fill: "#BFC4E8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M187.551 27.5081L185.785 28.3137C185.785 28.3137 188.123 33.0234 188.832 34.6277C189.579 36.3181 191.335 40.7628 192.027 42.5255C192.185 42.9248 192.646 43.1107 193.035 42.9317L193.838 42.5668C194.23 42.3877 194.392 41.9195 194.192 41.5374C193.311 39.8539 191.09 35.5883 190.298 33.9082C189.558 32.3314 187.544 27.5081 187.544 27.5081H187.551Z",
    fill: "#BFC4E8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M187.551 27.5081L185.785 28.3137C185.785 28.3137 188.123 33.0234 188.832 34.6277C189.579 36.3181 191.335 40.7628 192.027 42.5255C192.185 42.9248 192.646 43.1107 193.035 42.9317L193.838 42.5668C194.23 42.3877 194.392 41.9195 194.192 41.5374C193.311 39.8539 191.09 35.5883 190.298 33.9082C189.558 32.3314 187.544 27.5081 187.544 27.5081H187.551Z",
    fill: "#BFC4E8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M183.193 26.878C183.193 26.878 184.088 26.0036 184.435 25.7764C184.897 25.4768 185.179 25.3047 185.72 25.1911C186.718 24.9811 188.295 24.8881 190.085 26.6887L189.644 26.8884C189.644 26.8884 187.747 25.1911 187.262 26.2308C187.121 26.5372 187.572 27.5425 187.572 27.5425L185.809 28.3481C185.809 28.3481 185.09 26.9813 183.582 27.7181L183.196 26.8746L183.193 26.878Z",
    fill: "#BFC4E8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M183.193 26.878C183.193 26.878 184.088 26.0036 184.435 25.7764C184.897 25.4768 185.179 25.3047 185.72 25.1911C186.718 24.9811 188.295 24.8881 190.085 26.6887L189.644 26.8884C189.644 26.8884 187.747 25.1911 187.262 26.2308C187.121 26.5372 187.572 27.5425 187.572 27.5425L185.809 28.3481C185.809 28.3481 185.09 26.9813 183.582 27.7181L183.196 26.8746L183.193 26.878Z",
    fill: "#BFC4E8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M182.514 26.5807L182.689 26.5007C182.974 26.3706 183.308 26.4981 183.437 26.7799L183.823 27.6256C183.953 27.9106 183.826 28.245 183.544 28.3737L183.368 28.4537C183.083 28.5838 182.749 28.4563 182.62 28.1745L182.234 27.3288C182.104 27.0438 182.232 26.7094 182.514 26.5807Z",
    fill: "#BFC4E8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.514 26.5807L182.689 26.5007C182.974 26.3706 183.308 26.4981 183.437 26.7799L183.823 27.6256C183.953 27.9106 183.826 28.245 183.544 28.3737L183.368 28.4537C183.083 28.5838 182.749 28.4563 182.62 28.1745L182.234 27.3288C182.104 27.0438 182.232 26.7094 182.514 26.5807Z",
    fill: "#BFC4E8"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M205.36 110.537H79.9077V179.001H205.36V110.537Z",
    fill: "#90ADFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M205.36 171.856H79.8188V178.922H205.36V171.856Z",
    fill: "#9FAFFF"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M123.09 69H111.9V93.6782H123.09V69Z",
    fill: "#3E519E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M212.348 110.834H73L80.5026 98.1976H204.855L212.348 110.834Z",
    fill: "#3E519E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M186.668 86.3144H98.6096V179.001H186.668V86.3144Z",
    fill: "#C5CDFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M194.161 98.9409H91.1072L98.6098 86.3144H186.658L194.161 98.9409Z",
    fill: "#5363BC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M124.676 135.443V111.746H111.901V135.443H124.676Z",
    fill: "#9FAFFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M123.09 113.332H113.486V132.261H123.09V113.332Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M124.022 121.211H112.485V122.132H124.022V121.211Z",
    fill: "#9FAFFF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M117.034 112.648H116.162V121.934H117.034V112.648Z",
    fill: "#9FAFFF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M120.711 112.648H119.839V121.934H120.711V112.648Z",
    fill: "#9FAFFF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M126.152 135.473H110.434V138.347H126.152V135.473Z",
    fill: "#E6EAFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M126.152 137.138H110.434V138.416H126.152V137.138Z",
    fill: "#9FAFFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M172.159 135.443V111.746H159.384V135.443H172.159Z",
    fill: "#9FAFFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M170.573 113.332H160.97V132.261H170.573V113.332Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M171.505 121.211H159.969V122.132H171.505V121.211Z",
    fill: "#9FAFFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M164.518 112.648H163.646V121.934H164.518V112.648Z",
    fill: "#9FAFFF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M168.195 112.648H167.323V121.934H168.195V112.648Z",
    fill: "#9FAFFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M173.636 135.473H157.917V138.347H173.636V135.473Z",
    fill: "#E6EAFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M173.636 137.138H157.917V138.416H173.636V137.138Z",
    fill: "#9FAFFF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M174.26 107.385H109.076V111.736H174.26V107.385Z",
    fill: "#E6EAFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M135.151 135.552V117.633C135.151 113.787 138.283 110.656 142.129 110.656C145.974 110.656 149.106 113.787 149.106 117.633V135.552H135.161H135.151Z",
    fill: "#9FAFFF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M147.639 134.095H136.598V117.633C136.598 114.58 139.066 112.113 142.119 112.113C145.171 112.113 147.639 114.58 147.639 117.633V134.095Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M148.591 120.081V118.981H135.657V120.081H148.591Z",
    fill: "#9FAFFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M142.783 111.339H141.712V119.625H142.783V111.339Z",
    fill: "#9FAFFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M149.889 135.473H134.17V138.347H149.889V135.473Z",
    fill: "#E6EAFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M149.889 137.138H134.17V138.416H149.889V137.138Z",
    fill: "#9FAFFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M136.281 115.492H147.649C147.649 115.492 146.945 111.528 142.783 111.349C138.62 111.171 136.281 115.492 136.281 115.492Z",
    fill: "#9FAFFF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M186.668 171.935H98.6096V179.001H186.668V171.935Z",
    fill: "#9FAFFF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M151.951 147.029H131.921V179.001H151.951V147.029Z",
    fill: "#5363BC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M149.889 149.259H134.17V179.001H149.889V149.259Z",
    fill: "#3E51A3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M154.23 175.473H129.829V179.001H154.23V175.473Z",
    fill: "#E6EAFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M149.84 171.935H134.18V175.463H149.84V171.935Z",
    fill: "#AEBEFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M148.591 151.171H135.657V155.493H148.591V151.171Z",
    fill: "#5363BC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M148.591 156.731H135.657V170.607H148.591V156.731Z",
    fill: "#5363BC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M146.351 161.905C147.068 161.905 147.649 161.324 147.649 160.607C147.649 159.89 147.068 159.308 146.351 159.308C145.634 159.308 145.052 159.89 145.052 160.607C145.052 161.324 145.634 161.905 146.351 161.905Z",
    fill: "#E6EAFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9814 149.15V133.104H85.3292V149.15H93.9814Z",
    fill: "#5571D8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M92.911 134.174H86.4094V146.989H92.911V134.174Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5354 139.516H85.7256V140.141H93.5354V139.516Z",
    fill: "#5571D8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M88.808 133.718H88.2134V140.002H88.808V133.718Z",
    fill: "#5571D8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2956 133.718H90.7009V140.002H91.2956V133.718Z",
    fill: "#5571D8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9724 149.179H84.3281V151.132H94.9724V149.179Z",
    fill: "#E6EAFF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M94.9724 150.299H84.3281V151.162H94.9724V150.299Z",
    fill: "#9FAFFF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M200.464 149.15V133.104H191.812V149.15H200.464Z",
    fill: "#5571D8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M199.384 134.174H192.882V146.989H199.384V134.174Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M200.009 139.516H192.199V140.141H200.009V139.516Z",
    fill: "#5571D8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M195.281 133.718H194.687V140.002H195.281V133.718Z",
    fill: "#5571D8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M197.778 133.718H197.184V140.002H197.778V133.718Z",
    fill: "#5571D8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M201.455 149.179H190.811V151.132H201.455V149.179Z",
    fill: "#E6EAFF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M201.455 150.299H190.811V151.162H201.455V150.299Z",
    fill: "#9FAFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_309_2269",
    x: 0,
    y: 0,
    width: 274,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_309_2269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_309_2269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_2269"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_309_2269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 65,
    fill: "white",
    transform: "translate(39 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskWalkthrough);
export default __webpack_public_path__ + "static/media/TaskWalkthrough.13eb047433295707913e4c94b24b65c9.svg";
export { ForwardRef as ReactComponent };